import React from 'react';
import versionData from '../version.json';

const VersionBadge = () => {
  const buildDate = new Date(versionData.buildTime);
  const hostname = window.location.hostname;
  
  // Use deployment ID embedded at build time from version.json
  const deploymentId = versionData.deploymentId || '';

  // Determine environment type
  const getEnvironmentInfo = () => {
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return { env: 'LOCAL', color: 'text-blue-600' };
    }
    if (hostname.includes('preview.emergentagent.com')) {
      return { env: 'PREVIEW', color: 'text-purple-600' };
    }
    if (hostname.startsWith('staging.')) {
      return { env: 'STAGING', color: 'text-orange-600' };
    }
    return { env: 'PROD', color: 'text-green-600' };
  };
  
  const { env, color } = getEnvironmentInfo();
  
  // UTC format: "26-03-17 20:04:24 UTC"
  const utcFormatted = buildDate.toISOString()
    .replace('T', ' ')
    .replace(/\.\d{3}Z$/, '')
    .slice(2); // Remove century (20)
  
  // Local time with timezone
  const localOptions = {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  };
  const localFormatted = buildDate.toLocaleString(undefined, localOptions);

  return (
    <div className="fixed top-1 left-1/2 -translate-x-1/2 z-50 text-[10px] text-gray-500 whitespace-nowrap">
      <span className={`font-bold ${color}`}>[{env}]</span>
      <span className="mx-1">|</span>
      <span>Beta {utcFormatted} UTC ({localFormatted})</span>
    </div>
  );
};

export default VersionBadge;
